import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IElevatorsHasServiceTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const ElevatorsHasServiceTagItem = ({ onDeleteClick, withNewTag }: IElevatorsHasServiceTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Есть грузовой лифт
    </TagComponent>
  );
};
